import { trim } from "lodash";
import { BoardDescription, CardDescription } from "../kanban-board/kanban-types";
import { ConsultantOpportunityBoardFilter } from "./use-consultant-opportunity-board-context";
import { ConsultantOpportunityCardFragment } from "@graphql";

export function applyFilter(
  filter: ConsultantOpportunityBoardFilter,
  state: BoardDescription<ConsultantOpportunityCardFragment>
): BoardDescription<ConsultantOpportunityCardFragment> {
  console.log("applyFilter", state);

  let newState = { ...state };
  newState = applyTextSearch(filter, newState);
  newState = applyShowOld(filter, newState);

  return newState;
}

function applyTextSearch(
  filter: ConsultantOpportunityBoardFilter,
  state: BoardDescription<ConsultantOpportunityCardFragment>
): BoardDescription<ConsultantOpportunityCardFragment> {
  const text = trim(filter.text).toLowerCase();

  if (!text) {
    return state;
  }

  const filteredColumns = state.columns.map((column) => {
    return {
      ...column,
      cards: column.cards.filter((card) => {
        return card.title.toLowerCase().includes(text);
      })
    };
  });

  return {
    ...state,
    columns: filteredColumns
  };
}

function applyShowOld(
  filter: ConsultantOpportunityBoardFilter,
  state: BoardDescription<ConsultantOpportunityCardFragment>
): BoardDescription<ConsultantOpportunityCardFragment> {
  console.log("applyShowOld", state);

  const filteredColumns = state.columns.map((column) => {
    return {
      ...column,
      cards: column.cards.filter((card) => {
        if (isPresentedCard(card)) {
          return filter.showThisMonth
            ? isThisMonthOrEarlier(new Date(card.issue.dueDate))
            : true;
        }

        return filter.showOld
          ? isBeforeCurrentMonth(new Date(card.issue.consultantOpportunity.createdAt))
          : !isBeforeCurrentMonth(new Date(card.issue.consultantOpportunity.createdAt));
      })
    };
  });

  return {
    ...state,
    columns: filteredColumns
  };
}

function isBeforeCurrentMonth(dateToCheck: Date): boolean {
  const currentDate = new Date();

  const startOfCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  return dateToCheck < startOfCurrentMonth;
}

function isThisMonthOrEarlier(dateToCheck: Date): boolean {
  const currentDate = new Date();

  const endOfCurrentMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );

  return dateToCheck <= endOfCurrentMonth;
}

function isPresentedCard(
  card: CardDescription<ConsultantOpportunityCardFragment>
): boolean {
  return card.issue.consultantOpportunity.weeks.length > 0;
}
